/** @jsx jsx */
/** @jsxFrag null */
import {jsx} from 'panel';
import {VNode} from 'snabbdom';

import type {StickyPlaceholder} from './index';

export function template(this: StickyPlaceholder) {
  return (
    <div
      hook={{
        insert: (node: VNode) => this.helpers.onInsertStickyPlaceholder(node),
      }}
    />
  );
}
